import styled from 'styled-components'

export const Container = styled.div`
  padding: 0 0.625rem;
`
